const set_vaults = (state, payload) => {
  state.vault_list_object = payload
}

const set_vault = (state, payload) => {
  state.vault = payload
}

const set_login_token = (state, payload) => {
  state.vault_token = payload
}

const set_vault_transactions = (state, payload) => {
  state.vault_transactions_object = payload
}

export default {
  set_vaults,
  set_vault,
  set_login_token,
  set_vault_transactions
}


// WEBPACK FOOTER //
// ./src/modules/systemStates/store/mutations.js